// extracted by mini-css-extract-plugin
module.exports = {"nav":"DogDetail_nav__2XIBU","btn":"DogDetail_btn__aW7tX","container":"DogDetail_container__DnQBd","divImg":"DogDetail_divImg__27Bj0","description":"DogDetail_description__jD8Z-"};